import { ServiceFilterType } from '../../enums/ServiceFilterType';
import { ServicePortfolioType } from '../../enums/ServicePortfolioType';
import { Action } from '../../types/Action';
import { NoteResource, NotesCountMap } from '../../types/Note';
import { ServiceCustomerProfileModalResource } from '../../types/service-portfolio/ServiceCustomerProfileModalResource';
import {
  ServiceFilterResource,
  ServiceSelectedFilterResource,
} from '../../types/service-portfolio/ServiceFilterResource';
import { ServicePortfolioRequestResource } from '../../types/service-portfolio/ServicePortfolioRequestResource';
import { ServicePortfolioResource } from '../../types/service-portfolio/ServicePortfolioResource';
import { SortType } from '../../types/SortType';

export enum ServiceActionsType {
  SET_SERVICE_NOTES_MODAL_OPEN = 'Set service notes modal open',
  SET_SERVICE_NOTES_MODAL_RESOURCE = 'Set service notes modal resource',
  SET_SERVICE_CUSTOMER_PROFILE_MODAL_OPEN = 'Set service customer profile modal open',
  SET_SERVICE_ADD_FRESH_UP_MODAL_OPEN = 'Set service add fresh-up modal open',
  SET_SERVICE_CUSTOMER_PROFILE_MODAL_RESOURCE = 'Set service customer profile modal resource',
  SET_SERVICE_CLIENT_ACTIVATION_MODAL_OPEN = 'Set service client activation modal open',
  SET_SERVICE_CLIENT_ACTIVATED_SUCCESS_MODAL_OPEN = 'Set service client activated success modal open',
  SET_SERVICE_PORTFOLIO_IS_LOADING = 'Set service portfolio is loading',
  SET_SERVICE_FILTERS = 'Set service filters',
  SET_SERVICE_SELECTED_FILTERS = 'Set service selected filters',
  SET_IS_SERVICE_FILTERS_CHANGED = 'Set service is filter changed',
  SET_SERVICE_REQUEST_RESOURCE = 'Set service request resource',
  SET_SERVICE_SELECTED_SORT = 'Set service selected sort',
  SET_SERVICE_SELECTED_PAGE_SIZE = 'Set service selected page size',
  SET_SERVICE_SELECTED_CURRENT_PAGE = 'Set service selected current page',
  SET_SERVICE_DATA_TOTAL_COUNT = 'Set service data total count',
  SET_SERVICE_MASTER_FILTER = 'Set service Master Filter',
  SET_IS_SERVICE_FILTER_RESET = 'Set is service filter reset',
  SET_SERVICE_SHOULD_REFRESH = 'Should service portfolio refresh',
  SET_SERVICE_OPEN_FILTER_COUNT = 'Set service open filter count',
  SET_SELECTED_PORTFOLIO_TYPE = 'Set selected portfolio type',
  SET_SERVICE_UPDATED_NOTES_COUNT = 'Set service portfolio updated notes count',
  SET_SERVICE_NOTES_COUNT_MAP = 'Set service portfolio notes count map',
  SET_SELECTED_SERVICE_PORTFOLIO_TOTAL_RECORD = 'Set selected service portfolio total record',
  SET_SERVICE_IS_SERVICE_ONLY = 'Set isServiceOnly',
  SET_SERVICE_IS_CLOSED_DEAL_ONLY = 'Set isClosedDealOnly',
  SET_IS_FILTERS_SHOWING = 'Set is filters showing',
  SET_SERVICE_TOGGLE_UPDATE = 'Set service outreach/greeted toggle',
  SET_SERVICE_TOASTER_TEXT = 'Set service outreach/greeted toaster text',
  SET_RIGHT_MOBILE_LAYOUT = 'Set right mobile layout show/hide',
  SET_SELECTED_SERVICE_PORTFOLIO_RECORD = 'Set selected service portfolio record',
  SET_BULK_SELECTED_REDORDS = 'Set bulk selected records',
  SET_TOGGLE_ALL_ROWS_SELECTION = 'Set toggle all rows selection',
  SET_BULK_SELECTION_RESFRESH_COUNT = 'Set bulk selection refresh count',
  SET_IS_ALL_ROWS_SELECTED = 'Set is all rows selected',
}

export const setServicePortfolioRequestResource = (
  requestBody: ServicePortfolioRequestResource,
  dealType: string,
): Action => ({
  type: ServiceActionsType.SET_SERVICE_REQUEST_RESOURCE,
  payload: { requestBody: requestBody, dealType: dealType },
});

export const setServicePortfolioSort = (requestBody: SortType, dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_SELECTED_SORT,
  payload: { requestBody: requestBody, dealType: dealType },
});

export const setServicePortfolioPageSize = (pageSize: number, dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_SELECTED_PAGE_SIZE,
  payload: { pageSize: pageSize, dealType: dealType },
});

export const setServicePortfolioCurrentPage = (currentPage: number, dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_SELECTED_CURRENT_PAGE,
  payload: { currentPage: currentPage, dealType: dealType },
});

export const setServiceDataTotalCount = (value: number, dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_DATA_TOTAL_COUNT,
  payload: { value: value, dealType: dealType },
});

export const setServiceNotesModalOpen = (isNotesModalOpen: boolean): Action => ({
  type: ServiceActionsType.SET_SERVICE_NOTES_MODAL_OPEN,
  payload: isNotesModalOpen,
});

export const setServiceIsServiceOnly = (isServiceOnly: boolean): Action => ({
  type: ServiceActionsType.SET_SERVICE_IS_SERVICE_ONLY,
  payload: isServiceOnly,
});

export const setServiceIsClosedDealOnly = (isClosedDealOnly: boolean): Action => ({
  type: ServiceActionsType.SET_SERVICE_IS_CLOSED_DEAL_ONLY,
  payload: isClosedDealOnly,
});

export const setServiceNotesModalResource = (notesModalResource: NoteResource): Action => ({
  type: ServiceActionsType.SET_SERVICE_NOTES_MODAL_RESOURCE,
  payload: notesModalResource,
});

export const setServiceUpdatedNotesCount = (value: NotesCountMap, dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_UPDATED_NOTES_COUNT,
  payload: { value: value, dealType: dealType },
});

export const setServiceNotesCountMap = (value: NotesCountMap[], dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_NOTES_COUNT_MAP,
  payload: { value: value, dealType: dealType },
});

export const setIsCustomerProfileModalOpen = (isCustomerProfileModalOpen: boolean): Action => ({
  type: ServiceActionsType.SET_SERVICE_CUSTOMER_PROFILE_MODAL_OPEN,
  payload: isCustomerProfileModalOpen,
});

export const setIsAddFreshUpModalOpen = (isAddFreshUpModalOpen: boolean): Action => ({
  type: ServiceActionsType.SET_SERVICE_ADD_FRESH_UP_MODAL_OPEN,
  payload: isAddFreshUpModalOpen,
});

export const updateMasterFilterKey = (key: ServiceFilterType, dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_MASTER_FILTER,
  payload: { key: key, dealType: dealType },
});

export const setServiceCustomerProfileResource = (
  customerProfileModalResource: ServiceCustomerProfileModalResource,
): Action => ({
  type: ServiceActionsType.SET_SERVICE_CUSTOMER_PROFILE_MODAL_RESOURCE,
  payload: customerProfileModalResource,
});

export const setIsClientActivationModalOpen = (isClientActivationModalOpen: boolean): Action => ({
  type: ServiceActionsType.SET_SERVICE_CLIENT_ACTIVATION_MODAL_OPEN,
  payload: isClientActivationModalOpen,
});

export const setIsClientActivatedSuccessModalOpen = (
  isClientActivatedModalOpen: boolean,
): Action => ({
  type: ServiceActionsType.SET_SERVICE_CLIENT_ACTIVATED_SUCCESS_MODAL_OPEN,
  payload: isClientActivatedModalOpen,
});

export const setIsServicePortfolioLoading = (isLoading: boolean): Action => ({
  type: ServiceActionsType.SET_SERVICE_PORTFOLIO_IS_LOADING,
  payload: isLoading,
});

export const setServiceFilters = (filters: ServiceFilterResource, dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_FILTERS,
  payload: { filters: filters, dealType: dealType },
});

export const updateSelectedFilters = (
  filters: ServiceSelectedFilterResource,
  dealType: string,
): Action => ({
  type: ServiceActionsType.SET_SERVICE_SELECTED_FILTERS,
  payload: { filters: filters, dealType: dealType },
});

export const setIsServiceFiltersChanged = (value: boolean, dealType: string): Action => ({
  type: ServiceActionsType.SET_IS_SERVICE_FILTERS_CHANGED,
  payload: { value: value, dealType: dealType },
});

export const setIsServiceFilterReset = (isServiceFilterReset: boolean): Action => ({
  type: ServiceActionsType.SET_IS_SERVICE_FILTER_RESET,
  payload: isServiceFilterReset,
});

export const setServiceShouldRefresh = (value: boolean, dealType: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_SHOULD_REFRESH,
  payload: { value: value, dealType: dealType },
});

export const setServiceOpenFilterCount = (openFilterCount: number): Action => ({
  type: ServiceActionsType.SET_SERVICE_OPEN_FILTER_COUNT,
  payload: openFilterCount,
});

export const setIsFiltersShowing = (value: boolean): Action => ({
  type: ServiceActionsType.SET_IS_FILTERS_SHOWING,
  payload: value,
});

export const setSelectedPortfolioType = (value: ServicePortfolioType): Action => ({
  type: ServiceActionsType.SET_SELECTED_PORTFOLIO_TYPE,
  payload: value,
});

export const setSelectedServicePortfolioTotalRecord = (value: number): Action => ({
  type: ServiceActionsType.SET_SELECTED_SERVICE_PORTFOLIO_TOTAL_RECORD,
  payload: value,
});

export const setServiceToggleUpdate = (value: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_TOGGLE_UPDATE,
  payload: value,
});

export const setServiceToasterText = (value: string): Action => ({
  type: ServiceActionsType.SET_SERVICE_TOASTER_TEXT,
  payload: value,
});

export const setRightMobileLayout = (value: boolean): Action => ({
  type: ServiceActionsType.SET_RIGHT_MOBILE_LAYOUT,
  payload: value,
});

export const setSelectedServicePortfolioRecord = (value: ServicePortfolioResource): Action => ({
  type: ServiceActionsType.SET_SELECTED_SERVICE_PORTFOLIO_RECORD,
  payload: value,
});

export const setBulkSelectedRecors = (value: ServicePortfolioResource[]): Action => ({
  type: ServiceActionsType.SET_BULK_SELECTED_REDORDS,
  payload: value,
});

export const setToggleAllRowsSelection = (value: boolean): Action => ({
  type: ServiceActionsType.SET_TOGGLE_ALL_ROWS_SELECTION,
  payload: value,
});

export const setBulkSelectionRefreshCount = (value: number): Action => ({
  type: ServiceActionsType.SET_BULK_SELECTION_RESFRESH_COUNT,
  payload: value,
});

export const setIsALLRowsSelected = (value: boolean): Action => ({
  type: ServiceActionsType.SET_IS_ALL_ROWS_SELECTED,
  payload: value,
});

export type ServiceActions = ReturnType<
  | typeof setServiceNotesModalOpen
  | typeof setServiceNotesModalResource
  | typeof setIsCustomerProfileModalOpen
  | typeof setServiceCustomerProfileResource
  | typeof setIsClientActivationModalOpen
  | typeof setIsClientActivatedSuccessModalOpen
  | typeof setIsServicePortfolioLoading
  | typeof setServiceFilters
  | typeof updateSelectedFilters
  | typeof setIsServiceFiltersChanged
  | typeof setServicePortfolioRequestResource
  | typeof updateMasterFilterKey
  | typeof setIsServiceFilterReset
  | typeof setServiceDataTotalCount
  | typeof setServiceShouldRefresh
  | typeof setServiceOpenFilterCount
  | typeof setIsFiltersShowing
  | typeof setSelectedPortfolioType
  | typeof setServiceUpdatedNotesCount
  | typeof setServiceNotesCountMap
  | typeof setSelectedServicePortfolioTotalRecord
  | typeof setServicePortfolioSort
  | typeof setServicePortfolioPageSize
  | typeof setServicePortfolioCurrentPage
  | typeof setServiceIsServiceOnly
  | typeof setServiceIsClosedDealOnly
  | typeof setServiceToggleUpdate
  | typeof setServiceToasterText
  | typeof setIsAddFreshUpModalOpen
  | typeof setRightMobileLayout
  | typeof setSelectedServicePortfolioRecord
  | typeof setBulkSelectedRecors
  | typeof setToggleAllRowsSelection
  | typeof setBulkSelectionRefreshCount
  | typeof setIsALLRowsSelected
>;
